export default __webpack_public_path__ + "static/media/Yephome-Term-of-Use.e10545a0.md";